import {Injectable} from "@angular/core";
import {FindPaymentMethodsWs} from "@app/core/payment-method/infrastructure/find-payment-methods-ws";
import {PaymentMethodsDTOFinder} from "@app/core/payment-method/application/payment-methods-dto-finder";
import {catchError, map} from "rxjs/operators";
import {
    FindPaymentMethodsWsMapper
} from "@app/core/payment-method/infrastructure/mapper/find-payment-methods-ws-mapper";
import {Observable} from "rxjs";
import {PaymentMethodsDTO} from "@app/core/payment-method/application/payment-methods-dto";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";

@Injectable()
export class PaymentMethodsDTODataFinder implements PaymentMethodsDTOFinder {

    constructor(
        private readonly ws: FindPaymentMethodsWs,
        private readonly mapper: FindPaymentMethodsWsMapper,
    ) {}

    find(): Observable<PaymentMethodsDTO> {
        return this.ws.execute().pipe(
            map(response => this.mapper.map(response)),
            catchError(BaseHandleErrorMapper.handleError),
        )
    }

}